

'use strict';
{
  const globals = global;
  const django = globals.django || (globals.django = {});

  
  django.pluralidx = function(n) {
    const v = (n==1 ? 0 : (n%10>=2 && n%10<=4) && (n%100<12 || n%100>=14) ? 1 : n!=1 && (n%10>=0 && n%10<=1) || (n%10>=5 && n%10<=9) || (n%100>=12 && n%100<=14) ? 2 : 3);
    if (typeof v === 'boolean') {
      return v ? 1 : 0;
    } else {
      return v;
    }
  };
  

  /* gettext library */

  django.catalog = django.catalog || {};
  django.lang = "pl";
  
  const newcatalog = {
    "%(sel)s of %(cnt)s selected": [
      "Wybrano %(sel)s z %(cnt)s",
      "Wybrano %(sel)s z %(cnt)s",
      "Wybrano %(sel)s z %(cnt)s",
      "Wybrano %(sel)s z %(cnt)s"
    ],
    "%s ctg-search-cnt-label": [
      "%s wynik wyszukiwania",
      "%s wyniki wyszukiwania",
      "%s wynik\u00f3w wyszukiwania",
      "%s wynik\u00f3w wyszukiwania"
    ],
    "%s selected option not visible": [
      "%s wybrana opcja jest ukryta",
      "%s wybrane opcje s\u0105 ukryte",
      "%s wybranych opcji jest ukrytych",
      "%s wybranych opcji jest ukrytych"
    ],
    "April": "Kwiecie\u0144",
    "August": "Sierpie\u0144",
    "Available %s": "Dost\u0119pne %s",
    "Cancel": "Anuluj",
    "Choose": "Wybierz",
    "Choose a Date": "Wybierz Dat\u0119",
    "Choose a Time": "Wybierz Czas",
    "Choose a time": "Wybierz czas",
    "Choose all": "Wybierz wszystkie",
    "Chosen %s": "Wybrane %s",
    "Click to choose all %s at once.": "Kliknij, aby wybra\u0107 jednocze\u015bnie wszystkie %s.",
    "Click to remove all chosen %s at once.": "Kliknij, aby usun\u0105\u0107 jednocze\u015bnie wszystkie wybrane %s.",
    "December": "Grudzie\u0144",
    "February": "Luty",
    "Filter": "Filtr",
    "Hide": "Ukryj",
    "January": "Stycze\u0144",
    "July": "Lipiec",
    "June": "Czerwiec",
    "March": "Marzec",
    "May": "Maj",
    "Note: You are %s hour ahead of server time.": [
      "Uwaga: Czas lokalny jest przesuni\u0119ty o %s godzin\u0119 do przodu w stosunku do czasu serwera.",
      "Uwaga: Czas lokalny jest przesuni\u0119ty o %s godziny do przodu w stosunku do czasu serwera.",
      "Uwaga: Czas lokalny jest przesuni\u0119ty o %s godzin do przodu w stosunku do czasu serwera.",
      "Uwaga: Czas lokalny jest przesuni\u0119ty o %s godzin do przodu w stosunku do czasu serwera."
    ],
    "Note: You are %s hour behind server time.": [
      "Uwaga: Czas lokalny jest przesuni\u0119ty o %s godzin\u0119 do ty\u0142u w stosunku do czasu serwera.",
      "Uwaga: Czas lokalny jest przesuni\u0119ty o %s godziny do ty\u0142u w stosunku do czasu serwera.",
      "Uwaga: Czas lokalny jest przesuni\u0119ty o %s godzin do ty\u0142u w stosunku do czasu serwera.",
      "Uwaga: Czas lokalny jest przesuni\u0119ty o %s godzin do ty\u0142u w stosunku do czasu serwera."
    ],
    "November": "Listopad",
    "Now": "Teraz",
    "October": "Pa\u017adziernik",
    "Remove": "Usu\u0144",
    "Remove all": "Usu\u0144 wszystkie",
    "September": "Wrzesie\u0144",
    "Show": "Poka\u017c",
    "Today": "Dzisiaj",
    "Tomorrow": "Jutro",
    "Type into this box to filter down the list of available %s.": "Wpisz co\u015b tutaj, aby wyfiltrowa\u0107 list\u0119 dost\u0119pnych %s.",
    "Type into this box to filter down the list of selected %s.": "Wpisz co\u015b tutaj, aby wyfiltrowa\u0107 list\u0119 wybranych %s.",
    "Yesterday": "Wczoraj",
    "You have selected an action, and you haven\u2019t made any changes on individual fields. You\u2019re probably looking for the Go button rather than the Save button.": "Wybrano akcj\u0119, lecz nie dokonano \u017cadnych zmian w polach. Prawdopodobnie szukasz przycisku \u201eWykonaj\u201d, a nie \u201eZapisz\u201d.",
    "You have selected an action, but you haven\u2019t saved your changes to individual fields yet. Please click OK to save. You\u2019ll need to re-run the action.": "Wybrano akcj\u0119, lecz cz\u0119\u015b\u0107 zmian w polach nie zosta\u0142a zachowana. Kliknij OK, aby zapisa\u0107. Aby wykona\u0107 akcj\u0119, nale\u017cy j\u0105 ponownie uruchomi\u0107.",
    "You have unsaved changes on individual editable fields. If you run an action, your unsaved changes will be lost.": "Zmiany w niekt\u00f3rych polach nie zosta\u0142y zachowane. Po wykonaniu akcji, zmiany te zostan\u0105 utracone.",
    "cmn-clipboard": "Skopiowano do schowka",
    "cmn-currency-symbol": "z\u0142",
    "cmn-declination-donated": [
      "Wp\u0142aci\u0142a",
      "Wp\u0142aci\u0142y",
      "Wp\u0142aci\u0142o",
      "Wp\u0142aci\u0142o"
    ],
    "cmn-declination-person": [
      "osoba",
      "osoby",
      "os\u00f3b",
      "os\u00f3b"
    ],
    "cmn-error": "B\u0142\u0105d",
    "cmn-load-more": "Zobacz wi\u0119cej",
    "cmn-support-booked": "Twoja wp\u0142ata zosta\u0142a poprawnie zaksi\u0119gowana. Dzi\u0119kujemy!",
    "cmn-warning": "Uwaga",
    "ctg-find-project": "Znajd\u017a zbi\u00f3rk\u0119",
    "ctg-see-results-for": "Zobacz wyniki dla",
    "form-err-sth-went-wrong": "Co\u015b posz\u0142o nie tak.",
    "invc-download": "Pobierz",
    "msg-batch-file-size-exceeded %s": "Przekroczono \u0142\u0105czny dozwolony rozmiar przesy\u0142anych plik\u00f3w (%s MB)",
    "msg-file-exceeded %s": "Przekroczony dozwolony rozmiar pliku (%s MB)",
    "notif-title-ready": "Gotowe!",
    "prowiz-unsaved-changes": "Masz niezapisane zmiany. Czy na pewno chcesz opu\u015bci\u0107 stron\u0119?",
    "radio-no": "Nie",
    "radio-yes": "Tak",
    "supwiz-channel-credit-card": "Karta",
    "supwiz-complete-payment": "Doko\u0144cz wp\u0142at\u0119!",
    "supwiz-failed-or-canceled-payment": "P\u0142atno\u015b\u0107 nie powiod\u0142a si\u0119 lub zosta\u0142a przerwana.",
    "supwiz-form-err-donation-amount": "Upewnij si\u0119, \u017ce ta warto\u015b\u0107 jest mniejsza lub r\u00f3wna 30000",
    "supwiz-form-err-donation-threshold %s %s %s": "Maksymalna wp\u0142ata na rozw\u00f3j serwisu Pomagam.pl to %s% (%s %s)"
  };
  for (const key in newcatalog) {
    django.catalog[key] = newcatalog[key];
  }
  

  if (!django.jsi18n_initialized) {
    django.gettext = function(msgid) {
      const value = django.catalog[msgid];
      if (typeof value === 'undefined') {
        return msgid;
      } else {
        return (typeof value === 'string') ? value : value[0];
      }
    };

    django.ngettext = function(singular, plural, count) {
      const value = django.catalog[singular];
      if (typeof value === 'undefined') {
        return (count == 1) ? singular : plural;
      } else {
        return value.constructor === Array ? value[django.pluralidx(count)] : value;
      }
    };

    django.gettext_noop = function(msgid) { return msgid; };

    django.pgettext = function(context, msgid) {
      let value = django.gettext(context + '\x04' + msgid);
      if (value.includes('\x04')) {
        value = msgid;
      }
      return value;
    };

    django.npgettext = function(context, singular, plural, count) {
      let value = django.ngettext(context + '\x04' + singular, context + '\x04' + plural, count);
      if (value.includes('\x04')) {
        value = django.ngettext(singular, plural, count);
      }
      return value;
    };

    django.interpolate = function(fmt, obj, named) {
      if (named) {
        return fmt.replace(/%\(\w+\)s/g, function(match){return String(obj[match.slice(2,-2)])});
      } else {
        return fmt.replace(/%s/g, function(match){return String(obj.shift())});
      }
    };


    /* formatting library */

    django.formats = {
    "DATETIME_FORMAT": "j E Y H:i",
    "DATETIME_INPUT_FORMATS": [
      "%d.%m.%Y %H:%M:%S",
      "%d.%m.%Y %H:%M:%S.%f",
      "%d.%m.%Y %H:%M",
      "%Y-%m-%d %H:%M:%S",
      "%Y-%m-%d %H:%M:%S.%f",
      "%Y-%m-%d %H:%M",
      "%Y-%m-%d"
    ],
    "DATE_FORMAT": "j E Y",
    "DATE_INPUT_FORMATS": [
      "%d.%m.%Y",
      "%d.%m.%y",
      "%y-%m-%d",
      "%Y-%m-%d"
    ],
    "DECIMAL_SEPARATOR": ",",
    "FIRST_DAY_OF_WEEK": 1,
    "MONTH_DAY_FORMAT": "j E",
    "NUMBER_GROUPING": 3,
    "SHORT_DATETIME_FORMAT": "d.m.Y H:i",
    "SHORT_DATE_FORMAT": "d.m.Y",
    "THOUSAND_SEPARATOR": "\u00a0",
    "TIME_FORMAT": "H:i",
    "TIME_INPUT_FORMATS": [
      "%H:%M:%S",
      "%H:%M:%S.%f",
      "%H:%M"
    ],
    "YEAR_MONTH_FORMAT": "F Y"
  };

    django.get_format = function(format_type) {
      const value = django.formats[format_type];
      if (typeof value === 'undefined') {
        return format_type;
      } else {
        return value;
      }
    };

    /* add to global namespace */
    globals.pluralidx = django.pluralidx;
    globals.gettext = django.gettext;
    globals.ngettext = django.ngettext;
    globals.gettext_noop = django.gettext_noop;
    globals.pgettext = django.pgettext;
    globals.npgettext = django.npgettext;
    globals.interpolate = django.interpolate;
    globals.get_format = django.get_format;

    django.jsi18n_initialized = true;
  }
};

